<nav id="_navbar-top_" class="w-full flex items-center justify-around md:justify-start navbarTop">
  <!--  -->
  <div id="_navbar_TOP-LEFT_" class="px-2 pr-4 flex items-center justify-center">
    <!-- is MOBILE DEVICE  -->
    @if (session.isMobileDevice) {
      <div id="_mobile_top-left_" class="flex flex-auto items-center justify-center h-14" (click)="hamburgerOnClick()">
        <a class="p-1 visited:text-white">
          @if (!session.menuMobileLeftVisible) {
            <ism-svg [name]="'hamburger'" [classString]="'w-12 h-12 flex items-center text-white'"></ism-svg>
          }
          @if (session.menuMobileLeftVisible) {
            <ism-svg [name]="'xRound'" [classString]="'w-12 h-12  flex items-center text-white'"></ism-svg>
          }
          <!--  -->
        </a>
      </div>
    }
    <!-- is DESKTOP -->
    @else {
      <div id="_desktop_top-left_" class="flex items-center justify-center">
        <div ariaCurrentWhenActive="page" class="font-bold text-1.5 no-underline items-center hover:no-underline justify-center flex text-white">
          <div class="px-2 flex items-center justify-center">
            <ism-svg data-tooltip="Toggle ismTest Mode" class="tooltip-br" (click)="session.toggleISMtesting()" [name]="'saturnPurple'"></ism-svg>
          </div>
          <div data-tooltip="Back2-Campaign" class="tooltip-br" routerLink="/user/assignments" routerLinkActive="ngActiveLinkWhite">iSkyMarshal</div>
        </div>
      </div>
    }
  </div>
  <!--  -->
  <div id="_navbar-TOP-CENTER_" class="flex flex-1 items-center iBTTiny:justify-center md:justify-start">
    <!-- IS MOBILE DEVICE -->
    @if (session.isMobileDevice) {
      <div id="_mobile_top-center_" class="flex flex-none items-center justify-center" (click)="centerOnClick()">
        <a class="flex text-1.5 items-center no-underline hover:no-underline justify-center text-white" type="button">
          <div class="px-2 flex flex-none items-center justify-center">
            <!-- (click)="session.ismTesting=true" -->
            <ism-svg data-tooltip="Back2-Home" routerLink="/user/assignments" routerLinkActive="ngActiveLinkWhite" ariaCurrentWhenActive="page" class="tooltip-br" [name]="'saturnPurple'"></ism-svg>
          </div>
          <div class="pl-2">iSkyMarshal</div>
        </a>
        <!-- Mobile Top-Center Dropdown -->
        @if (session.menuMobileCenterVisible) {
          <div class="pb-4 w-1/2 absolute no-underline flex-none flex-col rounded-none items-center justify-center shadow-none cursor-pointer top-14 iBTTiny:flex whitespace-nowrap navbarLeft8 lg:hidden">
            <menu-items-center class="flex flex-col"></menu-items-center>
          </div>
        }
      </div>
    }
    <!-- IS DESKTOP -->
    @else {
      <div id="_desktop_top-center_" class="flex items-center">
        <div class="w-full no-underline flex flex-auto rounded-none items-center justify-start shadow-none cursor-pointer md:mx-4 whitespace-nowrap">
          <menu-items-center class="flex"></menu-items-center>
        </div>
      </div>
    }
  </div>
  <!--  -->
  <div id="_navbar-TOP-RIGHT_" class="flex flex-none items-center justify-center">
    <div id="_navbarTopRight" class="mx-4 flex items-center justify-end">
      <a id="_User-Name" class="flex items-center justify-end" (click)="rightOnClick()">
        <!-- IS MOBILE DEVICE -->
        @if (!session.isMobileDevice) {
          <div id="_user-name_" class="mx-6 text-1.25">
            {{ authService.getUser().first }}
          </div>
        }
        @if (!session.menuMobileRightVisible) {
          <ism-svg [name]="'manCircle'" [classString]="'w-12 h-12 flex items-center text-white hover:text-yellow-300 visited:text-white'"></ism-svg>
        } @else {
          <ism-svg [name]="'xRound'" [classString]="'w-12 h-12  flex items-center text-white hover:text-yellow-300'"> </ism-svg>
        }
      </a>
      <!-- Reminder: Both desktop & mobile share the SAME drop-down  user-menu -->
      @if (session.menuMobileRightVisible) {
        <div id="_user-menu_" class="px-2 top-0 right-0 absolute flex flex-col shadow-xl mt-[58px] navbarLeft8 rounded-b-md">
          <menu-items-right class="flex flex-col"></menu-items-right>
        </div>
      }
    </div>
  </div>
</nav>
